import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isDefinedNotNullNotEmpty, isUndefinedOrNullOrEmpty } from '@psnb/services';

export class GpsValidation {
  private static readonly MAX_DECIMAL_PLACES: number = 12;
  private static readonly MAX_LATITUDE: number = 50;
  private static readonly MAX_LONGITUDE_ABS: number = 130;
  private static readonly MIN_DECIMAL_PLACES: number = 6;
  private static readonly MIN_LATITUDE: number = 20;
  private static readonly MIN_LONGITUDE_ABS: number = 65;

  public static ValidateLongitudeLatitudeDecimal: () => ValidatorFn = (): ValidatorFn =>
    (control: AbstractControl): { validateDecimal: true } | undefined => {
      // Regular expression to validate latitude/longitude values with optional negative sign and 6 to 12 decimal places
      const rex: RegExp = new RegExp(
        `^-?\\d+(\\.\\d{${GpsValidation.MIN_DECIMAL_PLACES},${GpsValidation.MAX_DECIMAL_PLACES}})+$`
      );
      if (isDefinedNotNullNotEmpty(control.value) && !rex.test(control.value)) {
        return { validateDecimal: true };
      }
      return undefined;
    };

  public static ValidateLatitudeRange: () => ValidatorFn = (): ValidatorFn =>
    (control: AbstractControl): { validateRange: string } | undefined => {
      if (isDefinedNotNullNotEmpty(control.value) &&
        (control.value < GpsValidation.MIN_LATITUDE || control.value > GpsValidation.MAX_LATITUDE)
      ) {
        return {
          validateRange:
            `Latitude Coordinates Should be between ${GpsValidation.MIN_LATITUDE} to ${GpsValidation.MAX_LATITUDE}. Please Verify !`
        };
      }
      return undefined;
    };

  public static ValidateLongitudeRange: () => ValidatorFn = (): ValidatorFn =>
    (control: AbstractControl): { validateRange: string } | undefined => {
      if (isUndefinedOrNullOrEmpty(control.value)) {
        return undefined; // Skip validation if the field is empty
      }
      const absValue: number = control.value * -1;
      if (absValue <= GpsValidation.MAX_LONGITUDE_ABS && absValue >= GpsValidation.MIN_LONGITUDE_ABS) {
        return undefined;
      } else {
        return {
          validateRange:
            `Longitude Coordinates Should be between -${GpsValidation.MIN_LONGITUDE_ABS} to -${GpsValidation.MAX_LONGITUDE_ABS}. Please Verify !`
        };
      }
    };
}
